import styled, { css, keyframes } from 'styled-components';

import { RowCentered } from 'pages/Login/style';
import { pxToRem } from 'utils/scss';

export const ForgotPasswordTitle = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${pxToRem('35px')};
`;
export const ForgotPasswordText = styled.div`
  text-align: center;
  margin: ${pxToRem('25px')} ${pxToRem('70px')};
  line-height: 1.7;
`;
export const ForgotButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: ${pxToRem('60px')} auto;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: ${pxToRem('10px')} auto;
`;

export const InsertEmailTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${pxToRem('20px')};
`;
export const InsertEmailText = styled.div`
  margin: ${pxToRem('25px')} ${pxToRem('20px')};
  text-align: center;
`;
export const InvalidEmailText = styled.div`
  margin: ${pxToRem('0px')} ${pxToRem('20px')};
  text-align: center;
`;
export const ResendCode = styled.div`
  text-align: center;
  cursor: pointer;
  color: ${props => props.theme.colors.darkGreen}
    ${props =>
      props.isLoading &&
      css`
        opacity: 0.5;
        cursor: default;
        color: ${props => props.theme.colors.darkGray};
      `};
`;

export const PasswordSuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

export const PasswordSuccessHeader = styled.div`
  font-family: OpenSans;
  font-size: ${pxToRem('24px')};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  padding-bottom: ${pxToRem('15px')};
  margin: 0 -${pxToRem('32px')};
`;
export const SuccessIconWrapper = styled.span`
  padding-bottom: ${pxToRem('15px')};
  font-size: ${pxToRem('85px')};
`;
export const PasswordSuccessText = styled.div`
  font-family: OpenSans;
  font-size: ${pxToRem('14px')};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: center;
  padding-bottom: ${pxToRem('15px')};
  margin: 0 -${pxToRem('10px')};
`;

export const ErrorWrapper = styled(RowCentered)`
  justify-content: flex-start;
  padding-top: ${pxToRem('7px')};
`;

export const ErrorWrapperOtp = styled(RowCentered)`
  justify-content: center;
  padding-top: ${pxToRem('7px')};
`;

export const IconClose = styled.div`
  position: fixed;
  top: ${pxToRem('40px')};
  right: ${pxToRem('40px')};
  color: ${props => props.theme.colors.black.one};
  font-size: ${pxToRem('32px')};
  cursor: pointer;
`;
export const SendOTPText = styled.div`
  text-align: center;
  font-size: ${pxToRem('12px')};
  display: flex;
  justify-content: center;
  gap: ${pxToRem('10px')};
  margin-top: ${pxToRem('20px')};
`;
export const SubmitWrapper = styled.div`
  text-transform: uppercase;
  display: flex;
  gap: ${pxToRem('15px')};
  justify-content: center;
`;

export const RowForm = styled.div`
  padding-top: ${pxToRem('18px')};
  display: grid;
  justify-content: center;
`;

const spin = keyframes`
    0% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0deg);
    }
`;

export const StatusInProgressIcon = styled.div`
  width: ${pxToRem('56px')};
  height: ${pxToRem('56px')};
  font-size: ${pxToRem('10px')};

  border-radius: 50%;
  border: ${pxToRem('2px')} solid #00d7a3;
  border-left: 0.8em solid white;
  animation: ${spin} 1.1s infinite linear;
  margin: 0 auto;
`;

export const SpinnerContainer = styled.div`
  flex: 1 1 auto;
  height: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
